export namespace CancelSegmentNS {
  export const enum CancelType {
    'Segment' = 'Segment',
    'OtherElements' = 'OtherElements',
  }
}
